<template>
  <div class = "checkbox-wrapper" @click.stop="handleClick">
    <div :class = "['checkbox-container']">
        <div :class = "['checkbox-rect', { 'checked': isChecked || indeterminate }]">
          <svg v-if = "isChecked" class = "checkmark-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M7 13.4L3 9.4L4.4 8L7 10.6L13.6 4L15 5.4L7 13.4Z" fill="white"/>
          </svg>
          <svg v-else-if="indeterminate" class = "checkmark-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
            <path d="M5.09091 12.7273V10.1818H17.8182V12.7273H5.09091Z" fill="white"/>
          </svg>
        </div>
    </div>
    <div class = "checkbox-label">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VICheckbox',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    checkboxWrapperSize: {
      type: Number,
      default: 22,
    },
    checkboxRectSize: {
      type: Number,
      default: 18,
    },
    label: {
      type: String,
      default: ''
    },
    borderColor: {
      type: String,
      default: '#004879'
    },
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    hoverBackgroundColor: {
      type: String,
      default: 'rgba(30, 70, 112, 0.08)'
    },
    hoverBorderColor: {
      type: String,
      default: '#004879'
    },
    checkedBackgroundColor: {
      type: String,
      default: '#004879'
    }
  },
  data() {
    return {
      isChecked: this.modelValue
    }
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue(newVal) {
      if(newVal !== this.isChecked) {
        this.isChecked = newVal
      }
    },
    isChecked(newVal) {
      if(this.modelValue !== newVal) {
        this.$emit('update:modelValue', newVal)
      }
    },
    indeterminate(newVal) {
      if (newVal && this.isChecked) {
        this.isChecked = false;
      }
    }
  },
  computed: {
    finalCheckboxWrapperSize() {
      return this.checkboxWrapperSize + 'px'
    },
    finalCheckboxRectSize() {
      return this.checkboxRectSize + 'px'
    }
  },
  methods: {
    handleClick() {
      this.isChecked = !this.isChecked
    }
  }

}
</script>

<style scoped>
.checkbox-wrapper{
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.checkbox-container{
  height: v-bind(finalCheckboxWrapperSize);
  width: v-bind(finalCheckboxWrapperSize);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.checkbox-container:hover{
  background: v-bind(hoverBackgroundColor);
}
.checkbox-rect {
  border-radius: 4px;
  width: v-bind(finalCheckboxRectSize);
  height: v-bind(finalCheckboxRectSize);
  background: v-bind(backgroundColor);
  border: 1px solid v-bind(borderColor);
}
.checkbox-container:hover .checkbox-rect:not(.checked) {
  border-color: v-bind(hoverBorderColor);
  border-width: 2px;
  background: v-bind(hoverBackgroundColor);
}
.checkbox-rect.checked {
  background: v-bind(checkedBackgroundColor);
  border-color: v-bind(checkedBackgroundColor);
}
.checkmark-icon {
  width: 100%;
  height: 100%;
}
.checkbox-label {
  color: #4A4A4A;
  /* EHR_TitleS_14_WM */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
}
</style>
